import * as React from 'react';
import { observer } from 'mobx-react';
import style from './TabView.module.scss';
import { TabModel } from '../../../models';
import { JoinClassName } from '../../../utils/string';
import { DefaultLayout } from '../DefaultLayout';

interface TabViewActions {
  onChange: (tab: TabModel, index: number) => any;
}

interface TabViewProps extends TabViewActions {
  tabs: TabModel[];
  focused?: TabModel;
}

@observer
export class TabView extends React.Component<TabViewProps> {
  render() {
    const {
      tabs,
      focused,
      onChange,
    } = this.props;

    const hasFocused = focused !== undefined;

    return (
      <DefaultLayout className={style.container} isScroll={true}>
        {tabs.map((x, i) => (
          <div
            key={x.id}
            // 화면 밖에서 탭을 여는 자리. 글자로 찾으면 아무 글자나 걸린다 —
            // 인사등록의 `첨부파일` 은 화면에 두 번 나온다. 40개 화면이 이 컴포넌트를
            // 쓰므로 여기 한 줄이 전부를 연다.
            data-el-tab={typeof x.text === 'string' ? x.text : x.id}
            className={JoinClassName.make([
              style.tab,
              // eslint-disable-next-line no-nested-ternary, max-len
              hasFocused && x.id === focused?.id ? style.active : x.isEnabled ? style.active : false,
            ])}
            onClick={(e) => {
              // @ts-ignore
              if (e.target.className.indexOf('closer') > 0) {
                //
              } else {
                onChange(x, i);
              }
            }}
          >
            <div className={style.tab__cover}>
              <x.icon />
              <p>{x.text}</p>
            </div>
          </div>
        ))}
      </DefaultLayout>
    );
  }
}
